/**
 * News Paper Logos
 * --------------------------------------------------------------
 * Blog post metafield (custom.news_paper) ke har link ka naam ya URL
 * check karke uske hisaab se newspaper ka logo laga deta hai.
 *
 * NAYA NEWSPAPER ADD KARNA HO TO:
 * 1. Logo Shopify admin me Content → Files me upload karein
 * 2. Uska URL copy karein
 * 3. Neeche NEWSPAPER_LOGOS list me ek naya { ... } block add karein
 *
 * names   → link text me ye shabd ho to match (chhote-bade akshar se fark nahi padta)
 * domains → link URL me ye domain ho to match (agar naam match na ho)
 * logo    → logo image ka URL
 */

const NEWSPAPER_LOGOS = [
  {
    names: ['times of india', 'toi'],
    domains: ['timesofindia.indiatimes.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['hindustan times'],
    domains: ['hindustantimes.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['dainik bhaskar', 'bhaskar'],
    domains: ['bhaskar.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['dainik jagran', 'jagran'],
    domains: ['jagran.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['amar ujala'],
    domains: ['amarujala.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['the hindu'],
    domains: ['thehindu.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['indian express'],
    domains: ['indianexpress.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['ndtv'],
    domains: ['ndtv.com'],
    logo: 'PASTE_LOGO_URL_HERE'
  },
  {
    names: ['First Post'],
    domains: ['firstpost.com'],
    logo: 'https://cdn.shopify.com/s/files/1/0530/0148/6503/files/firstpost.webp?v=1792064207'
  }
];

(function () {
  'use strict';

  function normalize(str) {
    return (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function getHost(href) {
    try {
      return new URL(href, window.location.origin).hostname.toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function findNewspaper(text, href) {
    const name = normalize(text);
    const host = getHost(href);

    // 1. Pehle naam se match (lambe naam pehle check, taaki "jagran" se pehle "dainik jagran" mile)
    let best = null;
    let bestLength = 0;
    NEWSPAPER_LOGOS.forEach(function (paper) {
      (paper.names || []).forEach(function (n) {
        const key = normalize(n);
        if (key && name.indexOf(key) !== -1 && key.length > bestLength) {
          best = paper;
          bestLength = key.length;
        }
      });
    });
    if (best) return best;

    // 2. Naam match na ho to URL ke domain se match
    if (host) {
      for (let i = 0; i < NEWSPAPER_LOGOS.length; i++) {
        const domains = NEWSPAPER_LOGOS[i].domains || [];
        for (let j = 0; j < domains.length; j++) {
          const d = normalize(domains[j]);
          if (d && (host === d || host.endsWith('.' + d))) {
            return NEWSPAPER_LOGOS[i];
          }
        }
      }
    }
    return null;
  }

  function addLogos(root) {
    const links = (root || document).querySelectorAll('[data-np-link]');

    links.forEach(function (link) {
      if (link.dataset.npDone === '1') return;
      link.dataset.npDone = '1';

      const nameEl = link.querySelector('.np-name');
      const text = nameEl ? nameEl.textContent : link.textContent;
      const paper = findNewspaper(text, link.getAttribute('href'));

      if (!paper || !paper.logo || paper.logo.indexOf('PASTE_') === 0) {
        link.classList.add('np-no-logo');
        return;
      }

      const wrap = document.createElement('span');
      wrap.className = 'np-logo-wrap';

      const img = document.createElement('img');
      img.className = 'np-logo';
      img.src = paper.logo;
      img.alt = normalize(text) ? text.trim() : 'Newspaper logo';
      img.loading = 'lazy';
      img.decoding = 'async';

      // Logo load na ho to sirf naam dikhe
      img.addEventListener('error', function () {
        wrap.remove();
        link.classList.remove('np-has-logo');
        link.classList.add('np-no-logo');
      });

      wrap.appendChild(img);
      link.prepend(wrap);
      link.classList.add('np-has-logo');
      link.setAttribute('title', text.trim());
    });
  }

  function init() {
    addLogos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor me section add/edit hone par dobara chalaye
  document.addEventListener('shopify:section:load', function (e) {
    addLogos(e.target);
  });
})();
